import { create } from 'zustand';

export interface AppStoreType {
  isFormDirty: boolean;
  setIsFormDirty: (status: boolean) => void;
  showUnsavedWorkConfirmationModal: boolean;
  setShowUnsavedWorkConfirmationModal: (status: boolean) => void;
}

export const AppStore = create<AppStoreType>()((set) => ({
  isFormDirty: false,
  showUnsavedWorkConfirmationModal: false,
  setIsFormDirty: (status) => set({ isFormDirty: status }),
  setShowUnsavedWorkConfirmationModal: (status) =>
    set({ showUnsavedWorkConfirmationModal: status }),
}));
